/**
 * @generated SignedSource<<7228c8d0a5a0c28220fd892418d87827>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type thingsToDoHomeV2Query$data = {
  readonly thingToDoV2Queue: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly " $fragmentSpreads": FragmentRefs<"homeThingsToDoV2ContentItemContent">;
        };
      }>;
    } | null | undefined;
    readonly settings: unknown | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "thingsToDoHomeV2Query";
};
export type thingsToDoHomeV2Query$key = {
  readonly " $data"?: thingsToDoHomeV2Query$data;
  readonly " $fragmentSpreads": FragmentRefs<"thingsToDoHomeV2Query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "thingsToDoHomeV2Query",
  "selections": [
    {
      "alias": "thingToDoV2Queue",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "name": "homepage_service_journalism_hk"
          }
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "settings",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 3
            }
          ],
          "concreteType": "QueueItemConnection",
          "kind": "LinkedField",
          "name": "items",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "QueueItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "entityId",
                          "storageKey": null
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "homeThingsToDoV2ContentItemContent"
                        }
                      ],
                      "type": "Content",
                      "abstractKey": "__isContent"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "items(first:3)"
        }
      ],
      "storageKey": "queue(filter:{\"name\":\"homepage_service_journalism_hk\"})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "30de8be7ebf69c366b8a88c2ddb2a334";

export default node;
